// Auto-generated by tools/avatar/generate-face-svgs.mjs
 
import type { RecordOfEyesComponents } from './types'

import CloseSvg from './close.svg?raw'
import CrySvg from './cry.svg?raw'
import DefaultSvg from './default.svg?raw'
import DizzySvg from './dizzy.svg?raw'
import EyeRollSvg from './eye-roll.svg?raw'
import HappySvg from './happy.svg?raw'
import HeartsSvg from './hearts.svg?raw'
import SideSvg from './side.svg?raw'
import SquintSvg from './squint.svg?raw'
import SurprisedSvg from './surprised.svg?raw'
import WinkSvg from './wink.svg?raw'
import WinkWackySvg from './wink-wacky.svg?raw'

export const eyesComponents = {
  Close: CloseSvg,
  Cry: CrySvg,
  Default: DefaultSvg,
  Dizzy: DizzySvg,
  EyeRoll: EyeRollSvg,
  Happy: HappySvg,
  Hearts: HeartsSvg,
  Side: SideSvg,
  Squint: SquintSvg,
  Surprised: SurprisedSvg,
  Wink: WinkSvg,
  WinkWacky: WinkWackySvg,
} satisfies RecordOfEyesComponents

export type EyesComponentName = keyof typeof eyesComponents
